import { createElementBlock, openBlock, createElementVNode } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 14 14"
};
function render(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "m.218 9.576 1.478-7.942A2 2 0 0 1 3.662 0h.429a2 2 0 0 1 1.998 1.907L6.163 3.5h1.674l.074-1.593A2 2 0 0 1 9.91 0h.429a2 2 0 0 1 1.966 1.634l1.478 7.942a3.25 3.25 0 1 1-6.267.867L7.65 7.5h-1.3l.137 2.944q.015.15.014.306A3.25 3.25 0 1 1 .218 9.576M3.25 9a1.75 1.75 0 1 0 0 3.5 1.75 1.75 0 0 0 0-3.5m7.5 0a1.75 1.75 0 1 0 0 3.5 1.75 1.75 0 0 0 0-3.5",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const interfaceEditBinocular = { render };
export {
  interfaceEditBinocular as default,
  render
};
//# sourceMappingURL=interface-edit-binocular.svg.js.map
